import React from 'react';
import { Title, Content, ContentVariants } from '@patternfly/react-core';

type ListHeaderProps = {
  title: React.ReactNode;
  description?: React.ReactNode;
};

const ListHeader: React.FC<ListHeaderProps> = ({ title, description }) => {
  return (
    <>
      <Title headingLevel="h3">{title}</Title>
      {description ? <Content component={ContentVariants.p}>{description}</Content> : null}
    </>
  );
};

export default ListHeader;
